export default {
  switchActiveLanguage: 'English',
  stopAudio: 'Detener el Audio',
  playAudio: 'Poner el Audio',
};
